module.exports = __webpack_public_path__ + "static/media/up-arrow-dis.e05a5f12.svg";